import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/opticians")({
  head: () =>
    buildHead({
      path: "/opticians",
      jsonLd: buildFaqJsonLd(FAQS["/opticians"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Opticians", url: `${SITE_URL}/opticians` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/OpticiansLanding")),
});
